import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2",
        ul: "ul",
        li: "li"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'Thank you for visiting asadatik.dev. This Dispute Resolution Policy outlines the procedures for resolving any disputes or claims that may arise from your use of this personal website owned and operated by Asaduzzaman Atik ("I," "me," "my," or "mine"). By accessing and using asadatik.dev, you agree to comply with and be bound by this Dispute Resolution Policy. If you do not agree with any part of this policy, please refrain from using the Website. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. Informal Resolution 🤝"
            }),
            "\n",
            _jsx(_components.p, {
                children: "If you have any concerns, complaints, or disputes regarding asadatik.dev, I encourage you to first contact me at asadatik.me@gmail.com. I am committed to resolving any issues in an amicable and timely manner."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. Arbitration 🏛️"
            }),
            "\n",
            _jsx(_components.p, {
                children: "If an informal resolution cannot be reached, and a dispute arises, you and I agree to resolve the dispute through binding arbitration. Arbitration will be conducted in accordance with the rules of a recognized arbitration institution agreed upon by both parties."
            }),
            "\n",
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Arbitration shall be conducted by a single arbitrator appointed jointly by both parties, or if no agreement can be reached, by an arbitrator appointed by the selected arbitration institution."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "The arbitrator's decision will be final and binding on both parties."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "The arbitration proceedings shall be confidential, and any information related to the dispute will not be disclosed to third parties except as required by law."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Each party will bear its own costs and expenses related to the arbitration."
                    }),
                    "\n"
                ]
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Governing Law and Jurisdiction 📍"
            }),
            "\n",
            _jsx(_components.p, {
                children: "This Dispute Resolution Policy shall be governed by and construed in accordance with the laws of Bangladesh. Any legal action, claim, or proceeding arising from or related to asadatik.dev shall be brought exclusively in the courts of Bangladesh, and both parties consent to the personal jurisdiction of such courts."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "If you have any inquiries or questions regarding this Dispute Resolution Policy or any dispute-related issues on asadatik.dev, please contact me at asadatik.me@gmail.com"
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
